<template>
  <lu-popup :modal='true' ref='popup' class='spinner'>
    <lu-vbox lu-fullsize lu-flex lu-vcenter lu-hcenter>
      <lu-item class='loading'/>
      <lu-item class='loadingText'>{{ $t("Please wait...") }}</lu-item>
    </lu-vbox>
  </lu-popup>
</template>

<script>
import { LuVbox, LuItem, LuPopup } from 'lusis-ui'

export default {
  name: 'spinner',
  components: { LuVbox, LuItem, LuPopup },
  methods: {
    show: function () {
      this.$refs.popup.open()
    },
    hide: function () {
      this.$refs.popup.close()
    }
  }
}
</script>

<style scoped>
.spinner {
  transform: translate(-50%, 0%) !important;
  top: 0 !important;
  width: calc(100vw) !important;
  height: calc(100vh) !important;
  background-color: rgba(0, 0, 0, .3) !important;
}

.loading {
  width: 50px;
  height: 50px;
  background: url('../../assets/img/loading.gif');
  background-size: cover;
  background-repeat: no-repeat;
}

.loadingText {
  color: rgb(91, 215, 236);
  font-size: 16px;
  padding-top: 10px;
}
</style>